import { useEffect, useState } from 'react';
import { LOADING_SHOW_AFTER_MS, loadingElapsed, markLoadingTyped } from '../lib/loadingType';

const MESSAGE = 'Loading Daily Tribyoun…';
const CHAR_MS = 55;

// Full-screen loading state, typed out one character at a time like a wire
// teleprinter. A fast load shows only the blank paper: the type appears after
// LOADING_SHOW_AFTER_MS, so a cached session never flashes "Loa". The typing
// clock is shared across mounts (lib/loadingType.ts), so the next loading
// screen on the same load picks up mid-message instead of starting over.
// Screen readers get the whole message at once from the status region.
export function LoadingScreen() {
  const [shown, setShown] = useState(() => loadingElapsed() >= LOADING_SHOW_AFTER_MS);
  // How far into the typing this mount begins; fixed once, so re-renders don't shift it.
  const [offset, setOffset] = useState(() => Math.max(0, loadingElapsed() - LOADING_SHOW_AFTER_MS));

  useEffect(() => {
    if (shown) { markLoadingTyped(); return; }
    const t = setTimeout(() => {
      setOffset(Math.max(0, loadingElapsed() - LOADING_SHOW_AFTER_MS));
      setShown(true);
    }, LOADING_SHOW_AFTER_MS - loadingElapsed());
    return () => clearTimeout(t);
  }, [shown]);

  return (
    <div
      role="status"
      className="min-h-screen flex items-center justify-center bg-news-paper text-news-ink font-serif"
    >
      <span className="sr-only">{MESSAGE}</span>
      {shown && (
        <span aria-hidden="true" data-testid="loading-type">
          {Array.from(MESSAGE, (char, i) => (
            <span key={i} className="type-char" style={{ animationDelay: `${i * CHAR_MS - offset}ms` }}>
              {char}
            </span>
          ))}
          <span className="type-caret" />
        </span>
      )}
    </div>
  );
}
